/**
 * 提供全局常量
 * **/

/** 项目版本号 **/
export const VERSION = '1.0.0';

/** 接口版本号 **/
export const PORTVERSION = '1.0.0';

/** 存储用户信息key **/
export const USERINFOKEY = 'userinfo';

/** 存储用户菜单 */
export const USERMENUKEY = 'usermenu';

/** 双师logo地址 **/
export const LOGO = '';

/** 默认头像地址 **/
export const DEFAULTAVATAR = '';